
    import {
      getAllStaffRequirements,
      createStaffRequirement,
      createAllStaffRequirements,
      updateStaffRequirement,
      deleteStaffRequirement
    } from "@/services/staffRequirement";

    const state = {
      staffRequirements: [],
      processed: false
    };

    const getters = {
      getStaffRequirements(state) {
        return state.staffRequirements;
      },
      staffRequirementProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchStaffRequirements({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllStaffRequirements(
              params
            )
              .then(response => {
                commit("SET_STAFFREQUIREMENTS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createStaffRequirement({ commit }, staffRequirement) {
          return new Promise((resolve, reject) => {
            createStaffRequirement(staffRequirement)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllStaffRequirements({ commit }, staffRequirements) {
          return new Promise((resolve, reject) => {
            createAllStaffRequirements(staffRequirements)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateStaffRequirement({ commit }, staffRequirement) {
          return new Promise((resolve, reject) => {
            updateStaffRequirement(staffRequirement)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteStaffRequirement({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteStaffRequirement(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_STAFFREQUIREMENTS(state, data) {
        state.staffRequirements = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    